import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SlideDeleteValidator from "./SlideDeleteValidator";
import DeleteNewIcon from "../../images/DeleteNewIcon.svg";
import {
  deleteSlidesRequest,
  deleteChildSlideFromMaster,
} from "../../services/apis";
import { toggleLeftPanel } from "../../utils/editorUtils/commonFunctions";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

const SlideNextAndPrevious = ({
  slideID,
  setSlideID,
  currentSlide,
  setCurrentSlide,
  setSlideCount,
  editor,
  appData,
  childSlideCount,
  setChildSlideCount,
  loadSuccess,
  setLoadSuccess,
  setSaveLoading,
  slideCount,
}) => {
  let navigate = useNavigate();
  const [prompt, setPrompt] = useState(false);
  let list = [];
  const nextPage = async () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);
    setSaveLoading(true);
    toggleLeftPanel();
    let currentPage = filterCurrentPage();
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    if (currentPage < slideID.length - 1) {
      navigate(`/editor/${slideID[currentPage + 1].slideid?._id}`);
      setCurrentSlide({ master: slideIDInstance[currentPage + 1], child: {} });
      setSlideCount(currentPage + 2);
      // editor.editor.attributes.PageManager.select(
      //   slideID[currentPage + 1].slideid?._id
      // );
      setSlideID(slideIDInstance);
    } else if (currentPage === slideID.length - 1) return;
    toggleLeftPanel();
  };
  const filterCurrentPage = () => {
    return slideID.findIndex(
      (slide) => slide.slideid?._id === currentSlide.master.slideid?._id
    );
  };
  const previousPage = async () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);
    setSaveLoading(true);

    let currentPage = filterCurrentPage();
    let slideIDInstance = JSON.parse(JSON.stringify(slideID));
    toggleLeftPanel();
    if (currentPage > 0) {
      navigate(`/editor/${slideID[currentPage - 1].slideid?._id}`);
      setCurrentSlide({ master: slideIDInstance[currentPage - 1], child: {} });
      setSlideCount(currentPage);
      setSlideID(slideIDInstance);
    } else if (currentPage === 0) {
      return;
    }
  };

  const getCurrentMasterSlideIndex = () => {
    return (
      slideID?.findIndex(
        (slide) => slide?.slideid?._id === currentSlide?.master?.slideid?._id
      ) + 1
    );
  };
  const validateDelete = () => {
    // if (
    //   slideID.length === 1 ||
    //   (JSON.stringify(currentSlide.child) !== "{}" &&
    //     currentSlide?.master?.children.length > 1)
    // )
    //   return;
    // if (JSON.stringify(currentSlide?.child) !== "{}")
    //   if (currentSlide?.master?.children?.length === 1) return;

    // setPrompt(slideID?.length > 1);
    setPrompt(
      JSON.stringify(currentSlide?.child) === "{}"
        ? slideID.length > 1
          ? true
          : false
        : true
    );
  };
  //new script
  const deleteChildSlide = () => {
    toggleLeftPanel();
    let currentPageIndex = currentSlide?.master?.children?.findIndex(
      (child) => child?.slideid?._id === currentSlide?.child?.slideid?._id
    );

    let tempCurrentSlide = JSON.parse(JSON.stringify(currentSlide));
    let deleteChildFromMasterPayload = {
      children: [currentSlide?.child?.slideid?._id],
    };
    deleteChildSlideFromMaster(
      appData.deckId._id,
      tempCurrentSlide?.master?.slideid?._id,
      deleteChildFromMasterPayload,
      async (response, err, errorCode) => {
        if (err) {
          showErrorToast('Slide deletion failed. Please try again.');
        } else {
          showSuccessToast('Slide deleted successfully.');
          let tempSLidesList = JSON.parse(JSON.stringify(slideID));
          if (tempCurrentSlide?.master?.children === 1) {
            tempCurrentSlide.master.children = [];
            tempCurrentSlide.child = {};
            navigate(`/editor/${tempCurrentSlide?.master?.slideid?._id}`);
          } else {
            tempCurrentSlide?.master?.children?.splice(currentPageIndex, 1);
            // sortSLidesAfterDelete(
            //   tempCurrentSlide?.master?.children,
            //   currentSlide.master.index - 1
            // );
            if (Array.isArray(tempCurrentSlide?.master?.children)) {
              tempCurrentSlide.master.children.forEach((child, idx) => {
                  if (idx >= currentPageIndex && typeof child.index === 'number') {
                      child.index = child.index - 1;
                  }
              });
            }
            tempCurrentSlide.child = {};
            navigate(`/editor/${tempCurrentSlide?.master?.slideid?._id}`);
          }
          setCurrentSlide(tempCurrentSlide);
          let currentIndex = slideID.findIndex(
            (slide) =>
              slide.slideid?._id === tempCurrentSlide.master.slideid?._id
          );
          tempSLidesList[currentIndex] = tempCurrentSlide.master;
          setSlideID(tempSLidesList);
          window.localStorage.setItem(
            "removedSlieId",
            currentSlide?.child?.slideid?._id
          );
        }
      }
    );
  };

  //end
  const sortSLidesAfterDelete = (tempSlideId, initVal) => {
    for (let i = initVal; i < tempSlideId.length; i++) {
      tempSlideId[i].index = i + 1;
    }
  };
  const deleteSlide = () => {
    if (!loadSuccess) return;
    setLoadSuccess(false);
    setSaveLoading(true);
    setPrompt(false);
    if (JSON.stringify(currentSlide.child) !== "{}") {
      deleteChildSlide();
      return;
    }

    let currentPage = currentSlide.master.index - 1;
    deleteSlidesRequest(
      appData.deckId._id,
      slideID[currentPage].slideid?._id,
      async (response, err, errorCode) => {
        if (err) {
          showErrorToast('Deletion failed. Pl try again');
        } else {
          showSuccessToast('Deletion successful');
          const data = response.data;

          let tempSlideId = [...slideID];
          // let tempSlideId = [...response.data.slides];

          if (currentPage > 0) {
            navigate(`/editor/${slideID[currentPage - 1].slideid?._id}`);
            tempSlideId.splice(currentPage, 1);
            sortSLidesAfterDelete(tempSlideId, currentSlide.master.index - 1);
            setSlideID(tempSlideId);
            setCurrentSlide({ master: slideID[currentPage - 1], child: {} });
            setSlideCount(currentPage);
          } else if (currentPage === 0) {
            navigate(`/editor/${slideID[currentPage + 1].slideid?._id}`);
            tempSlideId.shift();
            sortSLidesAfterDelete(tempSlideId, 0);
            setSlideID(tempSlideId);
            setCurrentSlide({ master: slideID[currentPage + 1], child: {} });
            setSlideCount(currentPage + 1);
          }
        }
      }
    );
  };
  const getClassName = () => {
    return JSON.stringify(currentSlide?.child) === "{}"
      ? slideID.length > 1
        ? "new-slide-delete-icon "
        : "disableDelete  "
      : "new-slide-delete-icon ";
  };
  const lastPage = () => {
    return slideID?.length > 0
      ? slideID[slideID.length - 1].slideid?._id ===
      currentSlide?.master?.slideid?._id
      : false;
  };
  const firstPage = () => {
    return slideID?.length > 0
      ? slideID[0].slideid?._id === currentSlide?.master?.slideid?._id
      : false;
  };
  return (
    <>
      <div
        onClick={validateDelete}
        className={getClassName() + "ignoreClick d-flex align-items-center"}
        style={{ display: "flex" }}
      >
        <img src={DeleteNewIcon} alt="Delete slide" className="ignoreClick" />
        <h2 className="ignoreClick">Delete Slide</h2>
        {/* <li>
          <img
            src={NewSlideLeftArrowIcon}
            className={firstPage() ? "disableNavigate" : "new-slide-left-icon"}
            style={{ cursor: "pointer" }}
            alt=""
            onClick={() => !firstPage() && previousPage("prev")}
          />
        </li>
        <li>
          <img
            src={NewSlideRightArrowIcon}
            className={lastPage() ? "disableNavigate" : "new-slide-right-icon"}
            style={{ cursor: "pointer" }}
            alt=""
            onClick={() => !lastPage() && nextPage("next")}
          />
        </li> */}
      </div>
      {prompt && (
        <SlideDeleteValidator
          prompt={prompt}
          setPrompt={setPrompt}
          deleteSlide={deleteSlide}
          nthSlide={
            JSON.stringify(currentSlide?.child) !== "{}"
              ? childSlideCount
              : slideCount
          }
          child={JSON.stringify(currentSlide?.child) !== "{}"}
        />
      )}
    </>
  );
};

export default SlideNextAndPrevious;
